<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.clients.associations.associationRoleDialog.title' | translate }}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <form [formGroup]="roleForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off" >

        <div class="df gap20" *ngIf="data.formType == 'setGroupMainAdmin'"
            [ngClass]="{'hidden' : data?.admin}"
        >
            <app-phone-number-field formControlName="phone"
                                    class="grow"
                                    [autoFocus]="true"
                                    [appearance]="'outline'"
                                    [withCountry]="true"
                                    [label]="'modules.clients.associations.associationRoleDialog.placeholders.searchByPhone'">
            </app-phone-number-field>

            <div class="df jc-c ai-c">
                <button class="rounded-icon-button active" [disabled]="!roleForm.get('phone')!.valid" (click)="findUser()">
                    <mat-icon>person_search</mat-icon>
                </button>
            </div>
        </div>

        <autocomplete-item-field
                *ngIf="data.formType == 'hidden'"
                [dataType]="'MANAGER'"
                label="{{'користувач' | translate}}"
                formControlName="manager"
        >
        </autocomplete-item-field>

        <ng-container *ngIf="searchUserFinished && !userToAdd?.id && data.formType == 'setGroupMainAdmin'">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
                <mat-label>{{ 'modules.clients.associations.associationRoleDialog.labels.firstName' | translate }}</mat-label>
                <input type="text" matInput formControlName="firstName">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
                <mat-label>{{ 'modules.clients.associations.associationRoleDialog.labels.lastName' | translate }}</mat-label>
                <input type="text" matInput formControlName="lastName">
            </mat-form-field>
        </ng-container>

        <div class="dialog-subtitle-label bold" *ngIf="searchUserFinished && userToAdd?.id">
            {{ userToAdd?.lastName }} {{ userToAdd?.firstName }}
        </div>
        <div class="dialog-subtitle-label bold" *ngIf="data?.admin">
            {{ data?.admin?.user?.userName?.lastName }} {{ data?.admin?.user?.userName?.firstName }}
        </div>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width"
                        *ngIf="data.formType == 'setGroupMainAdmin' && (searchUserFinished || roleForm.get('manager')?.value || data?.admin)">
            <mat-label>{{ 'modules.clients.associations.associationRoleDialog.labels.position' | translate }}</mat-label>
            <input type="text" matInput [matAutocomplete]="auto" formControlName="position" (input)="onInput($event)">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let position of filteredPositions$ | async" [value]="position">
                    {{ position }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" *ngIf="(searchUserFinished || roleForm.get('manager')?.value) && data.formType == 'hidden'">
            <mat-label>{{ 'modules.clients.associations.associationRoleDialog.labels.role' | translate }}</mat-label>
            <mat-select formControlName="role">
                <mat-select-trigger>
                    {{ roleForm.get('role')?.value?.name }}
                </mat-select-trigger>
                <mat-option class="multiline-option" *ngFor="let role of roles$ | async" [value]="role">
                    <span>{{ role.name }}</span>
                    <span>{{ role.description }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>

<div class="buttons-row df jc-e ai-c">
    <button class="default-button apply-button" [disabled]="roleForm.invalid || (!(searchUserFinished || roleForm.get('manager')?.value) && !data.admin)" (click)="submitForm()">
        {{ 'common.save' | translate }}
    </button>
</div>
